<script>
    import TimepickerInline from "../course/TimepickerInline";
    import vSelect from 'vue-select';

    import Datepicker from 'vuejs-datepicker';
    import {it} from 'vuejs-datepicker/dist/locale';

    export default {
        name: 'SearchOrangopackFiltersContainer',
        components: {TimepickerInline, 'v-select': vSelect, 'datepicker': Datepicker,},
        //props: ['sports'],
        data() {
            return {
                filters: {
                    sport: "",
                    municipality: "",
                    partecipants: [],
                    age: 0
                },
                locale: it,
                sports: [],
                partecipants: {
                    1 : "1 persona",
                    2 : "2 persone",
                    3 : "3 persone",
                    4 : "4 persone",
                    5 : "5 persone",
                    6 : "6 persone",
                    7 : "7 persone",
                    8 : "8 persone",
                    9 : "9 persone",
                    10 : "10 persone",
                }
            };
        },
        computed: {
            'sportLabel': function () {
                return this.filters.sport != "" ? this.filters.sport : "Sport"
            },
            'ageLabel': function () {
                return this.filters.age != 0 ? this.filters.age + " anni" : "Età"
            }
        },
        watch: {

        },
        mounted() {
            console.log(this.sports);
            this.initPopover();
            this.$bus.$on("update-sports", this.updateSports);
        },
        methods: {
            isSelectedPartecipant(partecipant) {
                return this.filters.partecipants.includes(partecipant);
            },
            onSelectedPartecipant(partecipant) {
                (this.filters.partecipants.includes(partecipant)) ?
                    this.filters.partecipants = this.filters.partecipants.filter(item => item !== partecipant) :
                    this.filters.partecipants.push(partecipant)
            },
            updateSports(sports) {
                this.sports = sports
            },
            applyFilters(filter, menu) {
                this.toggleMenu($(this.$refs[filter]).attr("id"));
                this.$bus.$emit("update-filters", this.filters);
                if(menu != 'modalFiltersMobile')
                    $("#" + menu).dropdown('toggle');
                else
                    $("#" + menu).modal('toggle');
            },
            toggleMenu(menuId) {
                // $(".dropdown-menu").each(function (idx) {
                //     if ($(this).attr("id") == menuId) {
                //         $(this).dropdown('toggle');
                //     }
                // });
                // $(".dropdown-menu").each(function (idx) {
                //     if ($(this).attr("id") != menuId) {
                //         $(this).removeClass("show");
                //     }
                // });
                // if ($(`#${menuId}`).hasClass("show")) {
                //     $(".dropdown-menu").removeClass("show");
                //     $(".overlay-filters").removeClass("active");
                // } else {
                //     $(`#${menuId}`).toggleClass("show");
                //     $(".overlay-filters").addClass("active");
                // }
            },
            initPopover() {
                // $('[data-toggle="popover"]').popover();
                // $('[data-toggle="popover"]').on("click", function (e) {
                //     $('[data-toggle="popover"]')
                //         .not(this)
                //         .popover("hide");
                // });
                // $("[data-toggle=dropdown]").prop('onclick', null).off('click');
                $(".dropdown-menu.keepopen").click(function (e) {
                    e.stopPropagation();

                    // let el = $(this);
                    // let expanded = el.attr("aria-expanded") || false;
                    // if (!expanded) {
                    //     $(this).dropdown('toggle');
                    // }

                    // el.attr("aria-expanded", !expanded);
                })
            },

            onRemoveSportFilter(menu){
                this.filters.sport = [];
                $('#' + menu).dropdown('toggle')
                this.applyFilters('sport');
            },
            onRemoveAgeFilter(menu){
                this.filters.age = "";
                $('#' + menu).dropdown('toggle')
                this.applyFilters('age');
            },
            onRemovePartecipantFilter(menu) {
                this.filters.partecipants = [];
                $('#' + menu).dropdown('toggle')
                this.applyFilters('partecipants');
            },
            onRemoveAllFilters(){
                this.filters.sport = [];
                this.filters.age = "";
                this.applyFilters('sport','modalFiltersMobile');
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;

                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return "";

                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },
            incrementAge(){
                this.filters.age ++
            },
            decrementAge(){
                this.filters.age > 0 ? this.filters.age -- : this.filters.age = 0
            }

        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/orangopack/SearchOrangopackFiltersContainer.vue